// configs/tabsConfig.ts

import TabName from "../../components/controls/CustomTabs/TabName";
import RecordsDataTable from "../../components/controls/RecordsDataTable";
import { RecordDataType } from "../../interface";

export const tabsConfig = (
  limits: any,
  nrLoading: boolean,
  nrTotal: number,
  allLoading: boolean,
  allTotal: number,
  nrkLoading: boolean,
  nrkTotal: number,
  nrRecordWithSearch: RecordDataType[],
  allRecordWithSearch: RecordDataType[],
  nrkRecordWithSearch: RecordDataType[],
  setLimits: React.Dispatch<React.SetStateAction<any>>,
) => [
  {
    id: 1,
    tabName: (
      <TabName
        isLoading={nrLoading}
        currentCount={nrRecordWithSearch?.length}
        totalCount={nrTotal}
        label="Needs Review"
      />
    ),
    tabContent: (
      <RecordsDataTable
        rows={nrRecordWithSearch}
        isLoading={nrLoading}
        totalRecord={nrTotal}
        limit={limits.nr}
        updateLimit={(val) => setLimits((prev: any) => ({ ...prev, nr: val }))}
      />
    ),
  },
  {
    id: 2,
    tabName: (
      <TabName
        isLoading={allLoading}
        currentCount={allRecordWithSearch?.length}
        totalCount={allTotal}
        // label="All"   //Changed as part of reviewed tab
        label="Reviewed"
      />
    ),
    tabContent: (
      <RecordsDataTable
        rows={allRecordWithSearch}
        isLoading={allLoading}
        totalRecord={allTotal}
        limit={limits.all}
        updateLimit={(val) => setLimits((prev: any) => ({ ...prev, all: val }))}
      />
    ),
  },
  {
    id: 3,
    tabName: (
      <TabName
        isLoading={nrkLoading}
        currentCount={nrkRecordWithSearch?.length}
        totalCount={nrkTotal}
        label="No Risks"
      />
    ),
    tabContent: (
      <RecordsDataTable
        rows={nrkRecordWithSearch}
        isLoading={nrkLoading}
        totalRecord={nrkTotal}
        limit={limits.nrk}
        updateLimit={(val) => setLimits((prev: any) => ({ ...prev, nrk: val }))}
      />
    ),
  },
];
